import type {SaleVehiclePhotoPositionDto} from '@dms/api/vehicle';

import type {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

/**
 * Returns the regular album photos that a drag moved, with positions among the regular photos only.
 * Promo tiles are left out: their order is saved through the promo photo positions endpoint.
 */
export const getDirtyVehicleImages = (images: UnifiedAlbumImage[]): SaleVehiclePhotoPositionDto[] =>
  images
    .filter((image) => !image.isPromoPhoto)
    .flatMap((image, index) =>
      image.isDirty ? [{fileId: image.id, position: index, isPromoPhoto: image.isPromoPhoto}] : []
    );
